import { jsx as _jsx } from "react/jsx-runtime";
import { GraficoArea } from "@monorepo-web/components-library";
import { GraficoLinhaAreaPDF, BaseGraficoPDF } from "@monorepo-web/pdf-generator";
import { FormatTypes } from "@monorepo-web/utils";
export default function GraficoEvolucaoPatrimonioPDF(props) {
    const { data, moneyPrefix, config } = props;
    return (_jsx(BaseGraficoPDF, Object.assign({}, props, { idGraph: "EvolucaoPatrimonio", GraphComponent: GraficoArea, GraphComponentsProps: {
            data: data,
            tipo: FormatTypes.monetary_extense,
            assets: ['Carteira_retorno'],
            moneyPrefix: moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : null
        }, containerWidth: 550, containerHeight: 300, createPDFGraph: (svg) => new GraficoLinhaAreaPDF(config, svg, 'Evolução do Patrimônio', ['Carteira']) })));
}
